/// <reference types="@progress/kendo-ui" />

import * as React from 'react';
import * as ReactDOM from 'react-dom';

export interface KendoWidgetProps {
    widgetRef?(widget: kendo.ui.Widget): void;
}

class KendoBaseComponent<P extends KendoWidgetProps, S = {}> extends React.PureComponent<P, {}> {
    destroyed: boolean;
    widgetInstance: kendo.ui.Widget;
    widgetDestroy: Function;
    protected didMount: boolean = false;
    protected domNode: HTMLElement | null;

    componentDidMount(): void {
        this.exposeWidget();
        this.overrideDestroy();
        this.didMount = true;
    }

    componentWillUnmount(): void {
        if (!this.destroyed) {
            this.widgetDestroy.call(this.widgetInstance);
        }

        this.exposeWidget();
    }

    protected elementRef = (el: HTMLElement | null) => {
        this.domNode = el;
    }

    private exposeWidget = (): void => {
        if (this.props.widgetRef && typeof this.props.widgetRef === 'function') {
            (this.props.widgetRef as (widget: kendo.ui.Widget) => void)(this.widgetInstance);
        }
    }

    private overrideDestroy = (): void => {
        this.widgetDestroy = this.widgetInstance.destroy;

        this.widgetInstance.destroy = () => {
            this.destroyed = !this.destroyed;
            this.widgetDestroy.call(this.widgetInstance);
        };
    }
}

export default KendoBaseComponent;


// WEBPACK FOOTER //
// ./packages/kendo-base-component-react-wrapper/src/index.tsx